import type { ReactNode } from "react";

import type { RiskTier } from "@busright/data-contract";

const TIER_CLASS: Record<RiskTier, string> = {
  OK: "ok",
  WARN: "warn",
  CRITICAL: "crit",
};

const TIER_LABEL: Record<RiskTier, string> = {
  OK: "OK",
  WARN: "WARN",
  CRITICAL: "CRIT",
};

// RAG-colored risk pill. Color maps ONLY to risk tier (per design-system rule).
export const RiskTag = ({ tier }: { readonly tier: RiskTier }): ReactNode => (
  <span className={`tag ${TIER_CLASS[tier]}`}>
    <span className="dot" />
    {TIER_LABEL[tier]}
  </span>
);
